import { createPersonLevelExemption } from 'modules/exemptionReference/action';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useSaveExemptionCalculatorData = (
  personAccountId: string,
  professionalQualifications: State.ProfessionalQualification[] | undefined,
  educationalQualifications: State.EducationalQualification[] | undefined,
  workExperienceQualifications: State.WorkExperience[] | undefined
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [isQualificationsIncomplete, setIsQualificationsIncomplete] = useState(false);

  const dispatch = useDispatch();

  // these three qualification data will be empty if user did not fill in the needed forms
  // this will also prevent auto-saving of data once the page is refreshed since these data are not
  useEffect(
    () => {
      if (workExperienceQualifications?.length) {
        const saveData = async () => {
          try {
            setIsLoading(true);

            await dispatch(
              createPersonLevelExemption(
                personAccountId,
                professionalQualifications,
                educationalQualifications,
                workExperienceQualifications,
                ''
              )
            );
            setIsLoading(false);
          } catch (e) {
            setIsLoading(false);
            setHasError(true);
          }
        };
        saveData();
      } else {
        setIsQualificationsIncomplete(true);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { isLoading, hasError, isQualificationsIncomplete };
};
